<leap-suggestion-list [term]="term"></leap-suggestion-list>
